export default __webpack_public_path__ + "static/rprice-da5fdb26fbaaacce2c53423b0ff31c96.jpg";